import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DoodUserModel } from '@store/authentication/authentication.model';
import { DOOD_API } from '@config/ws.config';
import { HttpClient } from '@angular/common/http';
import { IZerosixCard } from '@core/models/zerosix.model';

export interface UserAgentPayload {
  ordering_context: 'kiosk' | 'click_and_collect' | null;
}

@Injectable({
  providedIn: 'root',
})
export class ZerosixApiService {
  constructor(private readonly httpClient: HttpClient) {}

  createZerosixUser$({
    marketplaceId,
    phoneNumber,
    ordering_context,
  }: {
    marketplaceId: string;
    phoneNumber: string;
  } & UserAgentPayload): Observable<DoodUserModel> {
    return this.httpClient.post<DoodUserModel>(
      `${DOOD_API}/marketplaces/${marketplaceId}/zerosix/user`,
      {
        phone_number: phoneNumber,
        ordering_context,
      },
    );
  }

  sendOtp$({
    marketplaceId,
    phoneNumber,
    ordering_context,
  }: {
    marketplaceId: string;
    phoneNumber: string;
  } & UserAgentPayload): Observable<DoodUserModel> {
    return this.httpClient.post<DoodUserModel>(
      `${DOOD_API}/marketplaces/${marketplaceId}/zerosix/send-otp`,
      {
        phone_number: phoneNumber,
        ordering_context,
      },
    );
  }

  getCard$({
    marketplaceId,
    shopId,
    ordering_context,
  }: {
    marketplaceId: string;
    shopId?: string;
  } & UserAgentPayload): Observable<IZerosixCard> {
    const params: Record<string, string> = {
      ...(ordering_context && { ordering_context }),
    };
    if (shopId) {
      params.shop_id = shopId;
    }
    const searchParams = new URLSearchParams(params);
    return this.httpClient.get<IZerosixCard>(
      `${DOOD_API}/marketplaces/${marketplaceId}/zerosix/card?${searchParams.toString()}`,
    );
  }

  /**
   * It will update the anonymous user in firebase with the Zerosix metadata.
   * And return the updated user.
   *
   */
  attachUserByPhone$({
    marketplaceId,
    phoneNumber,
    ordering_context,
  }: {
    marketplaceId: string;
    phoneNumber: string;
  } & UserAgentPayload) {
    let body: { phone_number: string } & UserAgentPayload = {
      phone_number: phoneNumber,
      ordering_context: ordering_context,
    };

    return this.httpClient.post<DoodUserModel>(
      `${DOOD_API}/marketplaces/${marketplaceId}/zerosix/attach-user`,
      body,
    );
  }

  attachUserByOtp$({
    marketplaceId,
    identification_code,
    ordering_context,
  }: {
    marketplaceId: string;
    identification_code: string;
  } & UserAgentPayload) {
    let body: { identification_code: string } & UserAgentPayload = {
      ordering_context: ordering_context,
      identification_code,
    };

    return this.httpClient.post<DoodUserModel>(
      `${DOOD_API}/marketplaces/${marketplaceId}/zerosix/attach-user`,
      body,
    );
  }
}
